import React from 'react'

import { Form, Col } from '_zari/core'

const CodigoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='CODIGO' htmlFor='input-codigo' xs={5} lg={6} alignRightAt='xs' />
      <Col xs={7} lg={6}>
        <Form.InputText defaultValue={iValue} disabled id='input-codigo' name='input-codigo' />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
